import React, { useState } from "react";
import { ScrollView, Text, View } from "react-native";

import { MOTION } from "../board/motionConfig";
import { useAssetStore } from "../../stores/useAssetStore";
import { getLoadedGraphVersion } from "../../services/dataLoader";
import { BUILD_COMMIT } from "../../dev/buildInfo";
import { copyText } from "../../dev/clipboard";
import { sandboxOn, useDevSession } from "../../dev/devSession";
import { last } from "../../dev/sessionLog";
import {
  formatSessionLog,
  sessionLogJson,
  settingsJson,
  settingsLine,
} from "../../dev/exportFormat";
import { Btn, Note, Row } from "./controls";
import { devStyles as s } from "./devStyles";

/** Copy settings / session log; the text stays shown to select by hand. */
const ExportSection: React.FC = () => {
  const [shown, setShown] = useState<{ text: string; ok: boolean } | null>(
    null,
  );
  const copy = async (text: string) =>
    setShown({ text, ok: await copyText(text) });
  const meta = () => {
    const dev = useDevSession.getState();
    const asset = useAssetStore.getState();
    return {
      graphVersion: asset.graphVersion ?? getLoadedGraphVersion(),
      graphHash: asset.graphHash,
      build: BUILD_COMMIT,
      sandbox: sandboxOn(dev),
    };
  };
  const lastGame = () => last(useDevSession.getState().games) ?? null;
  return (
    <View>
      <Row wrap>
        <Btn
          testID="dev-copy-line"
          label="Copy settings"
          onPress={() => copy(settingsLine(MOTION))}
        />
        <Btn
          testID="dev-copy-json"
          label="Settings JSON"
          onPress={() => copy(settingsJson(MOTION))}
        />
      </Row>
      <Row wrap>
        <Btn
          testID="dev-copy-log"
          label="Copy session log"
          onPress={() => copy(formatSessionLog(lastGame(), meta()))}
        />
        <Btn
          testID="dev-copy-log-json"
          label="Log JSON"
          onPress={() => copy(sessionLogJson(lastGame(), meta()))}
        />
      </Row>
      {shown && (
        <>
          <Note>
            {shown.ok ? "Copied." : "Clipboard blocked: select the text below."}
          </Note>
          <ScrollView style={s.copied}>
            <Text selectable testID="dev-copied-text" style={s.dim}>
              {shown.text}
            </Text>
          </ScrollView>
        </>
      )}
    </View>
  );
};

export default ExportSection;
